import { useSyncExternalStore } from 'react';

/** A phone, upright or turned on its side: narrow, or a touch screen that is not tall. Same as .no-phone in base.css. */
export const PHONE = '(max-width: 760px), (pointer: coarse) and (max-height: 520px)';

export function usePhone() {
  return useSyncExternalStore(
    (cb) => { const m = matchMedia(PHONE); m.addEventListener('change', cb); return () => m.removeEventListener('change', cb); },
    () => matchMedia(PHONE).matches,
  );
}
